import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { User } from "@auth0/auth0-react";

interface HeaderToolbarCreateProjectFormProps {
  show: boolean;
  isInProjectlist?: boolean;
  user?: User;
  projectName: string;
  onProjectNameChange: (projectName: string) => void;
  projectNameInputRef: React.RefObject<HTMLInputElement | null>;
  isDuplicateProjectName: boolean;
  isCreateDisabled: boolean;
  onCancel: () => void;
  onCreate: () => Promise<void>;
  t: (key: string) => string;
}

function HeaderToolbarCreateProjectForm({
  show,
  isInProjectlist,
  user,
  projectName,
  onProjectNameChange,
  projectNameInputRef,
  isDuplicateProjectName,
  isCreateDisabled,
  onCancel,
  onCreate,
  t,
}: HeaderToolbarCreateProjectFormProps) {
  if (!show || !isInProjectlist) return null;

  return (
    <Container style={{ height: 150 }} id="cont-create-new-project" className="mt-2 mb-2 pt-2 pb-2 border">
      <Row>
        <Col xs={12} className="mb-2">
          <span style={{ color: "#575757", fontSize: 14, fontWeight: "bold" }}>{t("create_new_project")}</span>
          <hr style={{ margin: 0 }} />
        </Col>
      </Row>

      <Row style={{ fontSize: 12 }} className="editfield-container">
        <Col>
          <Form.Group as={Row} className="mt-2">
            <Form.Label column xs={4} style={{ marginTop: 5, color: "#575757", fontWeight: "bold" }}>
              {t("project_name")}
            </Form.Label>
            <Col xs={8}>
              <Form.Control
                type="text"
                name="projectName"
                className="editfield editfield-border mt-2"
                value={projectName}
                onChange={(e) => onProjectNameChange(e.target.value)}
                placeholder={t("project_name")}
                ref={projectNameInputRef}
              />
              {user && isDuplicateProjectName && projectName !== "" && (
                <div className="text-danger mt-1" style={{ fontSize: 10 }}>
                  {t("project_name_already_exists")}
                </div>
              )}
            </Col>
          </Form.Group>

          <Row>
            <Col className="mt-3" style={{ textAlign: "right" }}>
              <Button className="action-btn-transparent me-2" onClick={onCancel}>
                {t("cancel")}
              </Button>
              {user && (
                <Button className="action-btn" disabled={isCreateDisabled} onClick={onCreate}>
                  {t("create")}
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default HeaderToolbarCreateProjectForm;
